export default __webpack_public_path__ + "img/login.3ae3dcec.png";